import { Heading } from 'components';
import { SectionP05 } from '../IntendendComponents';

const Prac05 = () => {
  return (
    <SectionP05>
      <Heading level={1}>Title</Heading>
      <Heading level={2}>Heading</Heading>
      <Heading level={3}>Sub-heading</Heading>
      <Heading level={4}>Sub-sub-heading</Heading>
      <Heading level={5}>Sub-sub-sub-heading</Heading>
      <Heading level={6}>Sub-sub-sub-sub-heading</Heading>
    </SectionP05>
  );
};

export default Prac05;
